var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M8.23 21.418v-9.836c0-.872.706-1.58 1.579-1.58h3.064c1.098 0 1.987-.89 1.987-1.987V2.988a1.988 1.988 0 0 0-2.278-1.966l-3.148.528a9.38 9.38 0 0 0-7.828 9.248v11.404c0 4.58 3.31 8.49 7.827 9.248l3.149.528a1.988 1.988 0 0 0 2.278-1.966v-5.027c0-1.098-.89-1.988-1.987-1.988H9.809a1.58 1.58 0 0 1-1.58-1.579M10.103 1.424v8.579M10.103 23.025v8.289M17.169 14.627c.48.48.776 1.141.776 1.873a2.64 2.64 0 0 1-.776 1.873M20.167 11.629a6.87 6.87 0 0 1 2.018 4.871 6.87 6.87 0 0 1-2.018 4.871M23.107 8.69a11 11 0 0 1 3.236 7.81c0 3.05-1.237 5.812-3.236 7.81"
  })));
};
export default SvgCall;